// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ezechiel (Ezekiel)",
  bookSlug: "ezechiel",
  chapter: 19,
  argument: "The parable of the young lions; and of the vine that is wasted.",
  verses: [
    { n: 1, text: "Moreover take thou up a lamentation for the princes of Israel," },
    { n: 2, text: "And say: Why did thy mother, the lioness, lie down among the lions, and bring up her whelps in the midst of young lions?" },
    { n: 3, text: "And she brought out one of her whelps, and he became a lion: and he learned to catch the prey, and to devour men." },
    { n: 4, text: "And the nations heard of him, and took him, but not without receiving wounds: and they brought him in chains into the land of Egypt." },
    { n: 5, text: "But she seeing herself weakened, and that her hope was lost, took one of her young lions, and set him up for a lion." },
    { n: 6, text: "And he went up and down among the lions, and became a lion: and he learned to catch the prey, and to devour men." },
    { n: 7, text: "He learned to make widows, and to lay waste their cities: and the land became desolate, and the fulness thereof, by the noise of his roaring." },
    { n: 8, text: "And the nations came together against him on every side out of the provinces, and they spread their net over him, in their wounds he was taken." },
    { n: 9, text: "And they put him into a cage, they brought him in chains to the king of Babylon: and they cast him into prison, that his voice should no more be heard upon the mountains of Israel." },
    { n: 10, text: "Thy mother is like a vine in thy blood, planted by the water: her fruit and her branches have grown out of many waters." },
    { n: 11, text: "And she hath strong rods, to make sceptres for them that bear rule, and her stature was exalted among the branches: and she saw her height in the multitude of her branches." },
    { n: 12, text: "But she was plucked up in wrath, and cast on the ground, and the burning wind dried up her fruit: her strong rods are withered, and dried up: the fire hath devoured her." },
    { n: 13, text: "And now she is transplanted into the desert, in a land not passable, and dry." },
    { n: 14, text: "And a fire is gone out from a rod of her branches, which hath devoured her fruit: so that she now hath no strong rod, to be a sceptre of rulers. This is a lamentation, and it shall be for a lamentation." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Princes: sons of Josias, who were so wretched. The latter part of this beautiful canticle, or allegory, (", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: ") regards Sedecias.", attribution: "Calmet" }
    ] },
    { verse: 2, notes: [
      { text: "Lioness; Jerusalem (Challoner) which made alliances with the lions, or nations.", attribution: "Calmet" }
    ] },
    { verse: 3, notes: [
      { text: "Whelps; Joachaz, or Sellum, (Challoner) who reigned only three months, like his brother Jechonias. (Haydock) — The four last kings were all cruel.", attribution: "Worthington" }
    ] },
    { verse: 4, notes: [
      { text: "But. Hebrew, \"he was taken in their pit,\" (Protestants; Haydock) as also [in]", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Septuagint, \"in his or their corruption.\" We do not read that Joachaz fought, (Calmet) though this passage insinuates as much. (Sanctius)", attribution: "4 Kings xxiii. 30., &c." }
    ] },
    { verse: 5, notes: [
      { text: "Lions: Joakim. (Challoner) — He reigned eleven years; but was such a monster, that the prophet does not speak of him or bewail his fate, 4 Kings xxiii. 34., and Jeremias xxii. 19. His words are applicable to Jechonias alone; who was cruel, and banished to Babylon,", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Rods. The king had many children, and confided in them, but they were slain.", attribution: "Haydock" }
    ] },
    { verse: 13, notes: [
      { text: "Dry; unfit for vine-trees. He speaks of the prison of Babylon. (Calmet) — The country was naturally wet.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Fire. Ismael, who slew Godolias, was of the royal family, Jeremias xli., &c.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
